import Slot from '@/models/Slot';
import Queue from '@/models/Queue';
import api from '../common/api/api';

export default class SlotsService {
  private readonly USER_ID: string = 'USER';

  public async enrollToSlot(uuid: string): Promise<Slot> {
    const { data }: { data: Slot } = await api.patch(`/slots/${uuid}/occupy`);
    return data;
  }

  public async signOffFromSlot(uuid: string): Promise<Slot> {
    const { data }: { data: Slot } = await api.patch(`/slots/${uuid}/free`);
    return data;
  }

  public async fetchSlotsForQueue(uuid: string, scope: number | null): Promise<Queue> {
    let props = '';

    if (scope) {
      props += `?scope=${scope}`;
    }

    const response = await api.get(`/queues/${uuid}/slots${props}`);
    const { data } = response.data;
    return data;
  }

  public async addSlotsToQueue(slots: unknown): Promise<void> {
    await api.post('/slots/batch', slots);
  }

  public static async deleteSlot(slotUuid: string): Promise<string> {
    const response = await api.delete(`/slots/${slotUuid}`);
    const { message }: { message: string } = response.data;
    return message;
  }

  /**
   * @param queueUuid
   * @param startDateTimestamp
   * @param endDateTimestamp
   * @param startHour
   * @param startMinute
   * @param endHour
   * @param endMinute
   * @param slotDuration
   * @param slotBreakDuration
   * @param skipWeekends
   * @return Returns queue object with newly generated slots and group of slots
   */
  public static async generateBatchOfSlots(
    queueUuid: string,
    startDateTimestamp: number,
    endDateTimestamp: number,
    startHour: number,
    startMinute: number,
    endHour: number,
    endMinute: number,
    slotDuration: number,
    slotBreakDuration: number,
    skipWeekends: boolean
  ): Promise<Queue> {
    const response = await api.post(`/queues/${queueUuid}/slots/batch`, {
      startDate: startDateTimestamp,
      endDate: endDateTimestamp,
      startHour,
      endHour,
      startMinute,
      endMinute,
      slotDuration,
      slotBreakDuration,
      skipWeekends
    });

    const { data } = response.data;
    return data;
  }
}
